/* RESPONSIBLE TEAM: team-inbox */

export interface TranslationQualityFeedbackWireFormat {
  rating: 1 | -1;
  reason_code: string | null;
}

export interface TranslationQualityFeedback {
  rating: 1 | -1;
  reasonCode: string | null;
}

export function deserializeTranslationQualityFeedbacks(
  feedbacks?: Record<string, TranslationQualityFeedbackWireFormat>,
): Record<string, TranslationQualityFeedback> | undefined {
  if (!feedbacks) {
    return undefined;
  }
  return Object.fromEntries(
    Object.entries(feedbacks).map(([locale, f]) => [
      locale,
      { rating: f.rating, reasonCode: f.reason_code },
    ]),
  );
}
